import { render, staticRenderFns } from "./BalanceAvaliable.vue?vue&type=template&id=db1b487a&scoped=true&"
import script from "./BalanceAvaliable.vue?vue&type=script&lang=js&"
export * from "./BalanceAvaliable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1b487a",
  null
  
)

export default component.exports